// components/portal/portalChrome.ts
'use client';

export const runIdentitySwitchCleanup = (kernelHandle: {
  clearActiveChatSession?: () => void;
  clearInventory?: () => void;
} | null | undefined): void => {
  if (!kernelHandle) return;
  kernelHandle.clearActiveChatSession?.();
  kernelHandle.clearInventory?.();
};
